/**
 * winess-variant-short-description.js
 *
 * Web Component that swaps the variant short description text when the user
 * picks a different variant. Subscribes to the theme's PUB_SUB_EVENTS.variantChange
 * (published by product-info.js) and looks up the new text from an inline
 * JSON map keyed by variant id.
 *
 * Plain text only — uses textContent (XSS-safe). The metafield is a
 * single_line_text_field, so HTML is not expected.
 */
class WinessVariantShortDescription extends HTMLElement {
  constructor() {
    super();
    this.textEl = this.querySelector('[data-winess-short-description-text]');
    this.mapEl = this.querySelector('[data-winess-short-description-map]');
    this.sectionId = this.dataset.sectionId;
    this.map = {};

    if (this.mapEl) {
      try {
        this.map = JSON.parse(this.mapEl.textContent) || {};
      } catch (e) {
        this.map = {};
      }
    }
  }

  connectedCallback() {
    if (!this.textEl || typeof subscribe !== 'function') return;

    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.variant) return;
      // Only react to changes within the same section (PDPs may share the page
      // with featured-product sections that also publish variantChange).
      if (this.sectionId && data.sectionId && String(data.sectionId) !== String(this.sectionId)) {
        return;
      }
      this.update(data.variant.id);
    });
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  }

  update(variantId) {
    if (variantId == null) return;
    const text = this.map[String(variantId)];
    // Defensive: leave the existing text in place if the variant has no value.
    if (text != null && text !== '') {
      this.textEl.textContent = text;
    }
  }
}

customElements.define('winess-variant-short-description', WinessVariantShortDescription);
